const rechargeUrl = window.location.href;
const rechargeHref = "recurring"
if(rechargeUrl.includes(rechargeHref)){
    const rechargeNav = document.getElementById("recharge-subscription")
    rechargeNav.classList.add('active')

    document.body.dataset.template = "customers/app";
    document.body.dataset.templateName = "recharge";
    document.body.dataset.templateDirectory = "customers";


const subscriptionHref = "subscriptions"
if(rechargeUrl.includes(subscriptionHref)){
    const rechargeNav = document.getElementById("subscriptions-page")
    rechargeNav.classList.add('active')
}

const scheduleHref = "schedule"
if(rechargeUrl.includes(scheduleHref)){
    const rechargeNav = document.getElementById("schedule-page")
    rechargeNav.classList.add('active')
}

const ordersHref = "orders"
if(rechargeUrl.includes(ordersHref)){
    const rechargeNav = document.getElementById("orders-page")
    rechargeNav.classList.add('active')
}

const shippingHref = "shipping"
if(rechargeUrl.includes(shippingHref)){
    const rechargeNav = document.getElementById("shipping-page")
    rechargeNav.classList.add('active')
}

const paymentHref = "payment_methods"
if(rechargeUrl.includes(paymentHref)){
    const rechargeNav = document.getElementById("payment_methods-page")
    rechargeNav.classList.add('active')
}

const noSubscription = "/tools/recurring/login"
if(rechargeUrl.includes(noSubscription)){
    const accountNavSubs = document.querySelector(".account-links-selected.account-nav [data-href='/subscription']")
    accountNavSubs.classList.add('active')
}

const mobileAccountNav = document.querySelector(".subscription-link")
mobileAccountNav.classList.add('active')
}